// extracted by mini-css-extract-plugin
export default {"footer-main":"Footer_footer-main__fru97"};